<template>
  <div>
    <el-dialog
      :close-on-click-modal="false"
      title=""
      :visible.sync="showModal"
      width="70%"
      :show-close="true"
      :before-close="closeModal"
    >
    <div class="border-b border-gray-300">
      <h3 class="absolute top-7 text-3xl text-black font-semibold josefin pl-10">Submit your application</h3>
    </div>
    <section class="flex px-4 py-4">
      <div class="w-3/12 flex justify-items-start items-center flex-col">
        <img src="@/assets/hiring-img.svg" />
        <h5 class="font-semibold text-xl pt-4 pb-1 text-black josefin">MedSchoolCoach</h5>
        <div class="flex items-center">
          <img src="@/assets/location.svg" alt="">
          <span class="pl-2 pt-1 text-secondary">Austin, TX</span>
        </div>
      </div>
      <div class="w-9/12 py-3 pr-8 lato">
        <h4 class="text-base font-normal text-[#292929] josefin pb-1"><span class="font-bold">Hourly rate:</span> $80/hr</h4>
        <h4 class="text-base font-normal text-[#292929] josefin pb-1"><span class="font-bold">Specialty/Subspecialty:</span> Anesthesiology</h4>
        <p class="py-3">MedSchoolCoach is a medical school admissions consulting company and is seeking talented physicians to join our team! We currently work with over a thousand pre-medical students each year to help them become successful applicants to medical school. As physicians, we know how difficult the process of applying to medical school can be and we use our experience and expertise to guide them through the entire... more</p>
        <div>
          <h3 class="pb-2">Cover Letter <span class="text-red-700">*</span></h3>
          <textarea
            rows="6"
            class="w-full bg-gray-100 focus:outline-none p-2 resize-none rounded-md"
            placeholder="Introduce yourself and let them know why you’re the best candidate for this job..."
          ></textarea>
        </div>
      </div>
    </section>
      <span slot="footer" class="josefin flex justify-between dialog-footer">
        <div class="cursor-pointer" @click="closeModal">
          <svg width="94" height="40" viewBox="0 0 94 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26 24L22 20L26 16" stroke="#292929" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M40.3327 13.932C41.5374 13.932 42.4604 14.2267 43.1017 14.816C43.7517 15.3967 44.0767 16.1767 44.0767 17.156C44.0767 17.702 43.9597 18.2393 43.7257 18.768C43.5004 19.2967 43.1147 19.717 42.5687 20.029L44.7917 23.5H42.5947L40.5797 20.458H39.3187V23.5H37.4337V13.932H40.3327ZM40.6577 18.638C41.0391 18.638 41.3337 18.56 41.5417 18.404C41.7584 18.2393 41.9101 18.0487 41.9967 17.832C42.0834 17.6067 42.1267 17.403 42.1267 17.221C42.1267 17.117 42.1094 16.987 42.0747 16.831C42.0487 16.6663 41.9881 16.5017 41.8927 16.337C41.7974 16.1723 41.6501 16.0337 41.4507 15.921C41.2601 15.8083 41.0001 15.752 40.6707 15.752H39.3187V18.638H40.6577ZM48.5879 23.656C47.8946 23.656 47.3053 23.526 46.8199 23.266C46.3433 23.006 45.9793 22.6463 45.7279 22.187C45.4766 21.7277 45.3509 21.199 45.3509 20.601C45.3509 20.029 45.4983 19.5133 45.7929 19.054C46.0876 18.5947 46.4819 18.2307 46.9759 17.962C47.4699 17.6847 48.0203 17.546 48.6269 17.546C49.4416 17.546 50.1089 17.7843 50.6289 18.261C51.1576 18.729 51.4999 19.4093 51.6559 20.302L47.4959 21.628C47.7733 21.9487 48.1503 22.109 48.6269 22.109C48.8263 22.109 49.0169 22.0743 49.1989 22.005C49.3896 21.9357 49.5759 21.8447 49.7579 21.732L50.5639 23.084C50.2606 23.2573 49.9313 23.396 49.5759 23.5C49.2293 23.604 48.8999 23.656 48.5879 23.656ZM47.1449 20.497C47.1449 20.5403 47.1449 20.5793 47.1449 20.614L49.6409 19.769C49.5629 19.5523 49.4373 19.366 49.2639 19.21C49.0906 19.0453 48.8306 18.963 48.4839 18.963C48.0766 18.963 47.7516 19.1017 47.5089 19.379C47.2663 19.6563 47.1449 20.029 47.1449 20.497ZM53.5115 15.323H55.3315V17.793H56.7095V19.21H55.3315V23.5H53.5115V19.21H52.6275V17.793H53.5115V15.323ZM59.9277 23.773C59.4164 23.773 58.9874 23.617 58.6407 23.305C58.294 22.9843 58.112 22.5727 58.0947 22.07V17.819H59.9147V21.394C59.932 21.6453 59.997 21.849 60.1097 22.005C60.2224 22.1523 60.413 22.226 60.6817 22.226C61.089 22.226 61.4097 22.031 61.6437 21.641C61.8777 21.2423 61.9947 20.7397 61.9947 20.133V17.819H63.8147V23.5H62.1637L62.0337 22.59C61.843 22.9453 61.57 23.2313 61.2147 23.448C60.8594 23.6647 60.4304 23.773 59.9277 23.773ZM67.3245 17.819L67.4675 19.119C67.6322 18.7897 67.8575 18.508 68.1435 18.274C68.4295 18.0313 68.7112 17.8493 68.9885 17.728C69.2658 17.598 69.4782 17.533 69.6255 17.533L69.5345 19.353C69.1098 19.301 68.7458 19.3703 68.4425 19.561C68.1392 19.7517 67.9052 20.003 67.7405 20.315C67.5758 20.627 67.4935 20.9477 67.4935 21.277V23.5H65.6865V17.819H67.3245ZM72.6695 17.819L72.7995 18.729C72.9989 18.3737 73.2805 18.0877 73.6445 17.871C74.0085 17.6543 74.4505 17.546 74.9705 17.546C75.5079 17.546 75.9542 17.7063 76.3095 18.027C76.6735 18.339 76.8599 18.7463 76.8685 19.249V23.5H75.0485V19.925C75.0399 19.6737 74.9705 19.4743 74.8405 19.327C74.7192 19.171 74.5112 19.093 74.2165 19.093C73.7919 19.093 73.4539 19.2923 73.2025 19.691C72.9599 20.081 72.8385 20.5793 72.8385 21.186V23.5H71.0185V17.819H72.6695Z" fill="#292929"/>
          </svg>
        </div>
        <el-button type="primary" @click="handleOpen" class="josefin">Submit</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'setVisibility'
  },
  props: ['visible'],
  data() {
    return {
      showModal: false
    }
  },
  watch: {
    visible(val) {
      this.showModal = val
    },
    showModal(val) {
      this.$emit('setVisibility', val)
    }
  },
  mounted() {
    this.showModal = this.visible
  },
  methods: {
    closeModal() {
      this.$emit('setVisibility', false)
    },
    handleOpen() {
      this.showModal = false
    }
  }
}
</script>

<style scoped>
* >>> .el-dialog__header {
  padding: 20px 20px 71px;
}

* >>> .el-dialog__body {
  padding: 0;
}
</style>